import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import styles from "../../assets/containers/lessonCard.module.css";
import { ArrowRightIcon } from "../../assets/icons/ArrowRight.js";
import { getUsage } from '../../service/service.js';
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";
import { getUserId } from "../../helpers/user";
import { getUsageWithFallback } from "../../helpers/progressFallback";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { t } from "../../lib/i18n";

const LessonCard = props => {

  const {isEmbedMode, fireNavigationEvents} = useAppGlobalConfig();
  const { lesson, groupIndex } = props;
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [tenant, setTenant] = useState();
  const [isComplete, setIsComplete] = useState(false);

  const handleLessonClick = async (lessonId) => {
    setIsLoading(true);

    let blockIndex = 0;
    try {
      const userInfo = JSON.parse(localStorage.getItem("user-info"));
      const usageProgressTrackerData = await getUsageWithFallback(userInfo.id, lessonId, tenant);
      const progress = usageProgressTrackerData.data.progress;
      let biggestIndex = Math.max(...progress);
      blockIndex = (biggestIndex === usageProgressTrackerData.data.totalSections - 1) ? biggestIndex : biggestIndex + 1;
    } catch (err) {
      if (err.status !== 404) {
        console.log("error getting student metrics: ", err);
        return;
      } 
    } finally {
      if(!isEmbedMode) localStorage.removeItem('lessons');
      setIsLoading(false);

      const location = `${isEmbedMode ? '/embeddable' : ''}/catchupId/1/lesson/${lessonId}/${blockIndex}`;
      localStorage.setItem('lessonName', lesson.name);
      history.push(location);

    }
  };

  const checkCompleteness = async () => {
    const userId = await getUserId();
    try {
      const usage = await getUsageWithFallback(userId, lesson.id, tenant);
      // If the length of the progress property equals the totalSections property, it means the user
      // has done all the blocks inside that lesson, thus completing the lesson.
      setIsComplete(usage.data.progress.length === usage.data.totalSections);
    } catch (err) {
      console.log("Error getting lesson ", lesson.name, ":", err.message);
      setIsComplete(false);
    }
  }

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise")
  }, []);

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise")
  }, [isEmbedMode]);

  useEffect(() => {
    if (lesson.id && tenant) {
      checkCompleteness();
    }
  }, [lesson.id, tenant]);

  return (
    <>
      <div key={groupIndex} className={styles["lesson-card"]}>
        {isLoading ? (
          <div className={styles["spinner-container"]}>
            <div className="spinner-border">
            </div>
          </div>
        ) : (
          <div className={styles["card-content"]}>
            <h2 className={styles["card-title"]}>{lesson.name}</h2>
            <div 
              className={styles["card-link"]}
              onClick={() => handleLessonClick(lesson.id)}>
                {t("Start Lesson")} <ArrowRightIcon className={styles["arrow-icon"]}/>
            </div>
            <div className={styles["card-completeness"]}>
              {isComplete && (
                  <>
                    <FontAwesomeIcon icon={faCheckCircle} size={"xs"} className={styles["card-completeness-icon"]} />
                    <span className={styles["card-completeness-text"]}>{t("Completed")}</span>
                  </>
              )}
            </div>
          </div>
        )}
      </div> 
    </>
  );
};

export default LessonCard;
